import { useEffect, useState } from "react";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  type User,
} from "firebase/auth";
import { auth } from "../lib/firebase";

export function useAuth() {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(
    () =>
      onAuthStateChanged(auth, (nextUser) => {
        setUser(nextUser);
        setLoading(false);
      }),
    [],
  );

  return {
    user,
    loading,
    signInWithEmail: (email: string, password: string) =>
      signInWithEmailAndPassword(auth, email, password),
    createAccount: (email: string, password: string) =>
      createUserWithEmailAndPassword(auth, email, password),
    signOutUser: () => signOut(auth),
  };
}
